import { render, staticRenderFns } from "./Sizes.vue?vue&type=template&id=f57c5c72&scoped=true&"
import script from "./Sizes.vue?vue&type=script&lang=js&"
export * from "./Sizes.vue?vue&type=script&lang=js&"
import style0 from "./Sizes.vue?vue&type=style&index=0&id=f57c5c72&lang=scss&scoped=true&"
import style1 from "./Sizes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57c5c72",
  null
  
)

export default component.exports